// extracted by mini-css-extract-plugin
export default {"buttonLink":"ButtonLink_buttonLink__C17y1","disabled":"ButtonLink_disabled__CSbc7"};